var _g, _path, _path2, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 264,
    viewBox: "0 0 254 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_10_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.319 168.516C161.831 150.524 145.995 136.945 126.976 136.945C107.957 136.945 92.1203 150.524 88.6325 168.516C87.8762 172.399 90.9464 176 94.897 176H159.043C163.005 176 166.064 172.41 165.308 168.516H165.319Z",
    fill: "url(#paint0_linear_10_50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.976 127.769C137.686 127.769 146.368 119.087 146.368 108.377C146.368 97.667 137.686 88.985 126.976 88.985C116.266 88.985 107.584 97.667 107.584 108.377C107.584 119.087 116.266 127.769 126.976 127.769Z",
    fill: "url(#paint1_linear_10_50)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.319 168.517C161.831 150.524 145.995 136.946 126.976 136.946C107.957 136.946 92.1203 150.524 88.6325 168.517C87.8762 172.399 90.9464 176 94.897 176H159.043C163.005 176 166.064 172.411 165.308 168.517H165.319Z",
    fill: "url(#paint2_linear_10_50)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.976 127.769C137.686 127.769 146.368 119.087 146.368 108.377C146.368 97.6674 137.686 88.9854 126.976 88.9854C116.266 88.9854 107.584 97.6674 107.584 108.377C107.584 119.087 116.266 127.769 126.976 127.769Z",
    fill: "url(#paint3_linear_10_50)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_10_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.291 166.62C107.911 144.068 88.0569 127.035 64.2179 127.035C40.3788 127.035 20.5243 144.068 16.1448 166.62C15.1966 171.496 19.0344 176 24.0008 176H104.424C109.39 176 113.228 171.496 112.28 166.62H112.291Z",
    fill: "url(#paint4_linear_10_50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2179 128.035C87.2086 128.035 106.418 144.209 111.1 165.792L111.298 166.811C112.122 171.048 108.784 175 104.424 175H24.0008C19.6409 175 16.3025 171.048 17.1264 166.811L17.1264 166.811C21.4164 144.72 40.8668 128.035 64.2179 128.035Z",
    stroke: "url(#paint5_linear_10_50)",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_10_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.7844 114.886C82.847 111.803 90.9371 98.7145 87.854 85.6519C84.771 72.5893 71.6823 64.4993 58.6197 67.5823C45.5571 70.6654 37.4671 83.754 40.5501 96.8166C43.6332 109.879 56.7218 117.969 69.7844 114.886Z",
    fill: "url(#paint6_linear_10_50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8808 85.8816C89.837 98.4067 82.0798 110.957 69.5547 113.913C57.0296 116.869 44.4796 109.112 41.5234 96.5869C38.5672 84.0618 46.3243 71.5118 58.8494 68.5556C71.3745 65.5994 83.9246 73.3565 86.8808 85.8816Z",
    stroke: "url(#paint7_linear_10_50)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10_50",
    x: 0.517334,
    y: 0.985046,
    width: 252.906,
    height: 263.015,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44,
    result: "effect1_foregroundBlur_10_50"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_10_50",
    x: -1.99988,
    y: 109.035,
    width: 132.424,
    height: 84.9648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10_50",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_10_50",
    x: 21.8948,
    y: 48.9269,
    width: 84.6146,
    height: 84.6146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10_50",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_50",
    x1: 126.976,
    y1: 197.491,
    x2: 126.976,
    y2: 80.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6005A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CBAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_50",
    x1: 126.976,
    y1: -420.359,
    x2: 126.976,
    y2: 80.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6005A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CBAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10_50",
    x1: 126.976,
    y1: 197.491,
    x2: 126.976,
    y2: 80.0683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6005A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CBAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10_50",
    x1: 126.976,
    y1: -420.359,
    x2: 126.976,
    y2: 80.0683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6005A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CBAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10_50",
    x1: 21.4438,
    y1: 173.236,
    x2: 56.5145,
    y2: 104.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10_50",
    x1: 22.8066,
    y1: 130.886,
    x2: 54.6,
    y2: 197.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10_50",
    x1: 48.1728,
    y1: 117.168,
    x2: 80.2314,
    y2: 65.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10_50",
    x1: 39.185,
    y1: 76.0969,
    x2: 88.7053,
    y2: 109.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.530e82b74d60a16645f0e67e06d8a036.svg";
export { ForwardRef as ReactComponent };